<p>Currently scheduled for cancellation on: {{ dateStringFromISO8601(membership.membership_cancel_date) }}</p>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
